export interface IncomeTaxDeclarationFour {
    item?: string,
    align: string,
    quantity?: string,
    amount?: string,
    indent?: number | string,
    isHead?: boolean,
    row?: string,
    justCol3?: boolean,
    canEdit?: boolean,
    rowspan?: number,
}

let list = [
    {
        item: "一、符合条件的小型微利企业减免企业所得税",
        align: "left",
        col: "1",
        row: "0",
        amount: "0",
        canEdit: true

    },
    {
        item: "二、国家需要重点扶持的高新技术企业减按15%的税率征收企业所得税",
        align: "left",
        col: "2",
        row: "1",
        amount: "0",
        canEdit: true
    },
    {
        item: "三、经济特区和上海浦东新区新设立的高新技术企业在区内取得的所得定期减免企业所得税",
        align: "left",
        col: "3",
        row: "2",
        amount: "0",
        canEdit: true
    },
    {
        item: "四、受灾地区农村信用社免征企业所得税",
        align: "left",
        col: "4",
        row: "3",
        amount: "0",
        canEdit: true
    },
    {
        item: "五、动漫企业自主开发、生产动漫产品定期减免企业所得税",
        align: "left",
        col: "5",
        row: "4",
        amount: "0",
        canEdit: true
    },
    {
        item: "六、线宽小于0.8微米（含）的集成电路生产企业减免企业所得税",
        align: "left",
        col: "6",
        row: "5",
        amount: "0",
        canEdit: true
    },
    {
        item: "七、线宽小于0.25微米的集成电路生产企业减按15%税率征收企业所得税",
        align: "left",
        col: "7",
        row: "6",
        amount: "0",
        canEdit: true
    },
    {
        item: "八、投资额超过80亿元的集成电路生产企业减按15%税率征收企业所得税",
        align: "left",
        col: "8",
        row: "7",
        amount: "0",
        canEdit: true
    },
    {
        item: "九、线宽小于0.25微米的集成电路生产企业减免企业所得税",
        align: "left",
        col: "9",
        row: "8",
        amount: "0",
        canEdit: true
    },
    {
        item: "十、投资额超过80亿元的集成电路生产企业减免企业所得税",
        align: "left",
        col: "10",
        row: "9",
        amount: "0",
        canEdit: true
    },
    {
        item: "十一、线宽小于130纳米的集成电路生产企业减免企业所得税",
        align: "left",
        col: "11",
        row: "10",
        amount: "0",
        canEdit: true
    },
    {
        item: "十二、线宽小于65纳米或投资额超过150亿元的集成电路生产企业减免企业所得税",
        align: "left",
        col: "12",
        row: "11",
        amount: "0",
        canEdit: true
    },
    {
        item: "十三、新办集成电路设计企业减免企业所得税",
        align: "left",
        col: "13",
        row: "12",
        amount: "0",
        canEdit: true
    },
    {
        item: "十四、国家规划布局内集成电路设计企业可减按10%的税率征收企业所得税",
        align: "left",
        col: "14",
        row: "13",
        amount: "0",
        canEdit: true
    },
    {
        item: "十五、符合条件的软件企业减免企业所得税",
        align: "left",
        col: "15",
        row: "14",
        amount: "0",
        canEdit: true

    },
    {
        item: "十六、国家规划布局内重点软件企业可减按10%的税率征收企业所得税",
        align: "left",
        col: "16",
        row: "15",
        amount: "0",
        canEdit: true
    },
    {
        item: "十七、符合条件的集成电路封装、测试企业定期减免企业所得税",
        align: "left",
        col: "17",
        row: "16",
        amount: "0",
        canEdit: true
    },
    {
        item: "十八、符合条件的集成电路关键专用材料生产企业、集成电路专用设备生产企业定期减免企业所得税",
        align: "left",
        col: "18",
        row: "17",
        amount: "0",
        canEdit: true

    },
    {
        item: "十九、经营性文件事业单位转制为企业的免征企业所得税",
        align: "left",
        col: "19",
        row: "18",
        amount: "0",
        canEdit: true
    },
    {
        item: "二十、符合条件的生产和装配伤残人员专门用品企业免征企业所得税",
        align: "left",
        col: "20",
        row: "19",
        amount: "0",
        canEdit: true
    },
    {
        item: "二十一、技术先进型服务企业（服务外包类）减按15%的税率征收企业所得税",
        align: "left",
        col: "21",
        row: "20",
        amount: "0",
        canEdit: true
    },
    {
        item: "二十二、技术先进型服务企业（服务贸易类）减按15%的税率征收企业所得税",
        align: "left",
        col: "22",
        row: "21",
        amount: "0",
        canEdit: true
    },
    {
        item: "二十三、设在西部地区的鼓励类产业企业减按15%的税率征收企业所得税",
        align: "left",
        col: "23",
        row: "22",
        amount: "0",
        canEdit: true
    },
    {
        item: "二十四、新疆困难地区新办企业定期减免企业所得税",
        align: "left",
        col: "24",
        row: "23",
        amount: "0",
        canEdit: true
    },
    {
        item: "二十五、新疆喀什、霍尔果斯特殊经济开发区新办企业定期免征企业所得税",
        align: "left",
        col: "25",
        row: "24",
        amount: "0",
        canEdit: true
    },
    {
        item: "二十六、广东横琴、福建平潭、深圳前海等地区的鼓励类产业减按15%税率征收企业所得税",
        align: "left",
        col: "26",
        row: "25",
        amount: "0",
        canEdit: true

    },
    {
        item: "二十七、北京冬奥组委、北京冬奥会测试赛赛事组委会免征企业所得税",
        align: "left",
        col: "27",
        row: "26",
        amount: "0",
        canEdit: true
    },
    {
        item: "二十八、其他（28.1+28.2+28.3+28.4）",
        align: "left",
        col: "28",
        row: "27",
        amount: "0",
        canEdit: false
    },
    {
        item: "1.从事污染防治的第三方企业减按15%的税率征收企业所得税",
        align: "left",
        col: "28.1",
        row: "28",
        amount: "0",
        indent: "20",
        canEdit: true
    },
    {
        item: "2.海南自由贸易港的鼓励类产业企业减按15%税率征收企业所得税",
        align: "left",
        col: "28.2",
        row: "29",
        amount: "0",
        indent: "20",
        canEdit: true
    },
    {
        item: "3.其他1",
        align: "left",
        col: "28.3",
        row: "30",
        amount: "0",
        indent: "20",
        canEdit: true
    },
    {
        item: "4.其他2",
        align: "left",
        col: "28.4",
        row: "31",
        amount: "0",
        indent: "20",
        canEdit: true
    },
    {
        item: "二十九、民族自治地方的自治机关对本民族自治地方的企业应缴纳的企业所得税中属于地方分享的部分减征或免征",
        align: "left",
        col: "29",
        row: "32",
        amount: "0",
        canEdit: true

    },
    {
        item: "三十、合计（1+2+3=4+5+6+…+29）",
        align: "left",
        col: "30",
        row: "33",
        amount: "0",
    }

]


let EITQuarterFour = list
export default EITQuarterFour
